
export  const ANSWER_TYPE = {
    T: 'T',
    N: 'N',
    A: 'A',
    B: 'B',
    C: 'C',
  };